import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

interface ProviderCardSkeletonProps {
	variant?: 'lobby' | 'content'
	className?: string
}

export function ProviderCardSkeleton({ variant = 'lobby', className }: ProviderCardSkeletonProps) {
	return (
		<Skeleton
			className={cn(
				'shrink-0 rounded-2xl',
				'[clip-path:polygon(0%_0%,100%_0%,100%_100%,72%_100%,62%_92%,38%_92%,28%_100%,0%_100%)]',
				variant === 'lobby' ? 'h-[140px]' : 'h-[88px]',
				className,
			)}
		/>
	)
}
